import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const QuantityStepper = (props) => {
    const { quantity, onIncrease, onDecrease, maxQuantity } = props;

    return (
        <div className="quantity-stepper">
            <button className="quantity-stepper__button decrease" onClick={onDecrease} disabled={quantity <= 1 || maxQuantity === 1} aria-label="Decrease quantity">
                <RemoveIcon fontSize='small' />
            </button>
            <input className="quantity-stepper__input" style={{
                color: 'black',
                width: '45px',
                height: '30px',
                fontSize: '16px',
                border: 'none',
                textAlign: 'center',
                '-webkit-appearance': 'none',
                '-moz-appearance': 'textfield',
                display: 'inline-block',
                padding: 0,
                borderRadius: 0,
                borderTop: '1px solid #767676',
                borderBottom: '1px solid #767676',
            }} type="text" min="0" aria-label="Quantity" value={quantity} />
            <button className="quantity-stepper__button increase" type="button" onClick={onIncrease} disabled={maxQuantity !== null && quantity >= maxQuantity} aria-label="Increase quantity">
                <AddIcon fontSize='small' />
            </button>
        </div>
    )   
};

export default QuantityStepper;

